<template lang="pug">
footer.c-the-footer.footer(:class="$style.root")
  .content.columns
    .column
      .subtitle 活動資訊
      div(:class="$style.link")
        router-link(:to="{ name: 'news' }") 最新消息
      div(:class="$style.link")
        router-link(:to="{ name: 'activity' }") 活動花絮
    .column
      .subtitle 關於同鄉會
      div(:class="$style.link")
        router-link(:to="{ name: 'intro-purpose' }") 宗旨
      div(:class="$style.link")
        router-link(:to="{ name: 'intro-rule' }") 章程
      div(:class="$style.link")
        router-link(:to="{ name: 'intro-pastchairmans' }") 歷屆理事長
      div(:class="$style.link")
        router-link(:to="{ name: 'intro-staffs' }") 18屆會務人員名冊
      div(:class="$style.link")
        router-link(:to="{ name: 'intro-advisors' }") 顧問團
    .column
      .subtitle 相關文件
      //div(:class="$style.link")
        router-link(:to="{ name: 'official_docs' }") 公文
      div(:class="$style.link")
        router-link(:to="{ name: 'applications' }") 辦法申請
  div(:class="$style.copyright")
    p COPYRIGHT © 2019 桃園市屏東同鄉會, ALL RIGHTS RESERVED.
</template>

<script>
export default {
  name: "TheFooter",
};
</script>

<style module lang="sass">
.root
  color: white

.link
  font-size: $size-6
  padding: pxRem(4) 0
  a
    color: $warning
    &:hover
      color: white

.root :global(.subtitle)
  color: white
  font-weight: bold

.copyright
  padding: 2rem 0 1rem 0
  text-align: center
</style>
